import { ControlledTextInput, ControlledDropdown, ControlledCheckbox } from '@Components/index';
import { t } from 'i18next';
import { Control } from 'react-hook-form';
import { OnboardingFormFields } from '@Types/index';
import { USA_STATES_LIST } from '@Types/consts';
import { IBusinessAdress } from '@Types/address';
interface IinputProps {
  control: Control<IBusinessAdress>;
  disabled: boolean;
}

interface CheckboxProps extends Omit<IinputProps, 'disabled'> {
  onChange: (isChecked: boolean) => void;
}

export const SameAddressCheckboxInput = ({ control, onChange }: CheckboxProps) => {
  return (
    <ControlledCheckbox
      id={OnboardingFormFields.BUSINESS_ADDRESS_SAME_AS_PRIMARY}
      control={control}
      name={OnboardingFormFields.BUSINESS_ADDRESS_SAME_AS_PRIMARY}
      handleOnChange={onChange}
    />
  );
};

export const AptInput = ({ control, disabled }: IinputProps) => {
  return (
    <ControlledTextInput
      control={control}
      name={OnboardingFormFields.APARTMENT}
      title={t('pages.businessAddress.fields.apt')}
      // id={'line2'}
      id={OnboardingFormFields.APARTMENT}
      disabled={disabled}
    />
  );
};

export const CityInput = ({ control, disabled }: IinputProps) => {
  return (
    <ControlledTextInput
      control={control}
      name={OnboardingFormFields.CITY}
      title={t('pages.businessAddress.fields.city')}
      // id={'city'}
      id={OnboardingFormFields.CITY}
      disabled={disabled}
    />
  );
};

export const StateInput = ({ control, disabled }: IinputProps) => {
  return (
    <ControlledDropdown
      control={control}
      name={OnboardingFormFields.STATE}
      title={t('pages.businessAddress.fields.state')}
      items={USA_STATES_LIST}
      // id={'elSelectState'}
      id={OnboardingFormFields.STATE}
      disabled={disabled}
    />
  );
};
